import { QueryClient } from "@tanstack/vue-query";

/**
 * QueryClient PARTAGÉ de l'app. Exporté en singleton pour que du code hors
 * composant (ex. listeners Reverb dans src/services/*) puisse invalider des
 * queries — `useQueryClient()` n'est utilisable que dans un setup().
 *
 * Défauts alignés sur l'archi cache : refetch-on-focus (converge vers le
 * frais en multi-poste), retry léger, staleTime court par défaut.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60_000,
			refetchOnWindowFocus: true,
			retry: 1,
		},
	},
});
